export interface IEpiProps {
    buildSearchPrompt: string;
    buildSearchHint: string;
    narrowSearchPrompt: string;
    searchHint: string;
    searchFromHint: string;
    searchToHint: string;
    addAnotherLabel: string;
    searchLabel: string;
    changeContextTitle: string;
    changeContextPrompt: string;
    searchPage: string;
}

export class EpiProps implements IEpiProps {
    buildSearchPrompt: string = '';
    buildSearchHint: string = '';
    narrowSearchPrompt: string = '';
    searchHint: string = '';
    searchFromHint: string = '';
    searchToHint: string = '';
    addAnotherLabel: string = '';
    searchLabel: string = '';
    changeContextTitle: string = '';
    changeContextPrompt: string = '';
    searchPage: string = '';
}